var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commission-module"},[_c('div',{staticClass:"navbar"},_vm._l((_vm.sections),function(section){return _c('router-link',{key:section.path,attrs:{"to":section.path},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('div',{staticClass:"navi-section"},[_c('a',{attrs:{"active":isActive,"href":href},on:{"click":navigate}},[_vm._v(_vm._s(section.name))])])]}}],null,true)})}),1),_c('router-view',{staticClass:"body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }